export class ConControlPanelPersonEntity{
    id:number;
    controlPanelId:number;
    personId:number;

    constructor(){}
}